import type { BrandSlug } from '../shared/brand-slug';
import type { EAN } from '../shared/ean';
import type { OrgId } from '../shared/ids';
import { type Entitlement, emptyEntitlement } from './entitlement';

/** One atomic parse of the org row: the aggregate plus the catalog data riding on it. */
export type EntitlementSnapshot = {
  readonly entitlement: Entitlement;
  /** Catalog EAN→brand facts cached by the provisioner in the row's `b` fields; covers exactly the category-caused EANs. */
  readonly catalogBrandByEan: ReadonlyMap<EAN, BrandSlug>;
};

export function emptyEntitlementSnapshot(orgId: OrgId): EntitlementSnapshot {
  return { entitlement: emptyEntitlement(orgId), catalogBrandByEan: new Map() };
}

export abstract class EntitlementRepository {
  abstract forOrg(orgId: OrgId): Promise<EntitlementSnapshot>;

  /**
   * Brand-majority projection: derived globally from
   * portal_references.ean_w_data_counts_per_brand_category. Lives here
   * because callers consume it alongside Coverage data.
   */
  abstract loadBrandCategorySkuCounts(): Promise<BrandCategorySkuCounts>;
}

export type BrandCategorySkuCounts = Readonly<
  Record<string, Readonly<Record<string, { w_data: number; no_data: number }>>>
>;
